module.exports = __webpack_public_path__ + "img/01_uk.41a6456e.svg";